export const FooterCategories = [
  {
    key: 1,
    name: 'Overview',
    links: [
      {text: 'Products', 'address': '/products'},
      {text: 'Industries & Cases', address: '/industries'},
      //'Blog',
      {text: 'Pricing', address: '/pricing'},
      {text: 'Developers', address: '/developers'},
      {text: 'Help & Guides', address: '/help-and-guides'}
    ]
  },
  {
    key: 2,
    name: 'About Us',
    nameAddress: '/our-story',
    links: [
     {text: 'Our Story', address: '/our-story'},
     {text: 'Press Kit (English)', address: '/press'},
     {text: 'Pers (Nederlands)', address: '/pers'},
      //'Blog',
      //'Career'
      {text: 'Contact Us', address: '/contact'}
    ]
  },
  {
    key: 3,
    name: 'Help',
    nameAddress: '/help-and-guides',
    links: [
      {text: 'Get Started', address: '/help-and-guides#get-started'},
      {text: 'Aircheckr Data API', address: '/help-and-guides#aircheckr-data-api'},
      {text: 'Importance of AQ (monitoring)', address: '/help-and-guides#importance-of-air-quality'},
      {text: 'aircheckr Legal', address: '/help-and-guides#aircheckr-legal'}
    ]
  },
  {
    key: 4,
    name: 'Developers',
    nameAddress: '/developers',
    links: [
      {text: 'Basics', address: '/developers'},
      {text: 'API Documentation', address: '/api_docs', isExternal: true}
      //'Widget'
    ]
  },
  {
    key: 5,
    name: 'Industries',
    nameAddress: '/industries',
    links: [
      {text: 'Home & Office', address: '/industries/homeandoffice'},
      {text: 'Informative', address: '/industries/info'},
      {text: 'Outdoor', address: '/industries/outdoor'},
      {text: 'Digital health', address: '/industries/health'},
      {text: 'Automotive', address: '/industries/auto'},
      {text: 'Intelligence', address: '/industries/intelli'}
    ]
  }
];

export const FooterSocialText = {
  title: 'Yes, keep me posted',
  follow: 'Follow us:',
  subscribe: 'Subscribe'
}

export const Copyright = {
  contact: {
    text: 'Contact Us',
    address: '/contact'
  },
  termsOfUse: {
    text: 'Terms of Use',
    linkAddress: 'https://legal.nazka.be/docs/en/terms-of-use/'
  }
}

export default FooterCategories;



// WEBPACK FOOTER //
// ./src/input-text/en/footer.js